import {
  VirtualTableColumnDef as ColumnDef,
} from 'core/components/VirtualTable/types';
import {
  VisitNoteServiceCode,
} from 'views/EMR/components/ServiceLookup/type';
import EditableCurrencyField from 'views/EMR/components/EditableCurrencyField';

const editableMeta = {
  editable: {
    Component: EditableCurrencyField,
    alwaysEditable: true,
  },
  autoSized: true,
};

export default {
  id: 'billedAmount',
  accessorFn: (row: VisitNoteServiceCode) => row?.serviceCodeDetails?.billedAmount,
  header: 'Charge',
  minSize: 80,
  maxSize: 100,
  meta: editableMeta,
} as ColumnDef<VisitNoteServiceCode>;
